import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { ModalService } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { AppService } from 'src/app/app.service';
import type { KWHConfig } from '../../kwh.model';
import { CredentialsComponent } from '../credentials/credentials.component';

@Component({
  selector: 'app-kwh-basic-infos',
  templateUrl: './basic-infos.component.html',
  styleUrl: './basic-infos.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule],
})
export class BasicInfosComponent {
  constructor(
    private ngxModalService: ModalService,
    private appService: AppService,
  ) {}
  kwhSettings = input.required<KWHConfig>();

  isDisabled = input(false, { transform: booleanAttribute });

  get isAtruvia() {
    return this.appService.isAtruvia;
  }

  openCredentialsModal(anonymizedAtruvia = false) {
    const settings = this.kwhSettings();
    this.ngxModalService.addModal(CredentialsComponent, {
      link: anonymizedAtruvia
        ? 'https://10090901.test.kwh.fino.digital'
        : settings.clientUrlTesting,
      username: 'Schulung',
      password: anonymizedAtruvia
        ? parseInt('10090901').toString(16)
        : parseInt(settings.blz).toString(16),
      atruviaSystem: anonymizedAtruvia,
    });
  }
}
